module.exports = __webpack_public_path__ + "img/sign_up_title.b410da78.png";